(() => {
  const selectors = {
    carousel: '.se-cart-reassurance__carousel',
    wrapper: '.se-cart-carousel-wrapper',
  };

  function canInit() {
    return typeof window.$ === 'function' && typeof window.$.fn?.slick === 'function' && document.querySelector(selectors.carousel);
  }

  function initCarousel() {
    if (!canInit()) return;
    const $carousel = window.$(selectors.carousel);
    if ($carousel.hasClass('slick-initialized')) return;

    $carousel.slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 2,
      prevArrow:
        '<div class="se-arrow-left"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
      nextArrow:
        '<div class="se-arrow-right"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
    });
  }

  document.addEventListener('DOMContentLoaded', initCarousel);

  document.addEventListener('CartDrawer:open', () => {
    if (!canInit()) return;
    const $carousel = window.$(selectors.carousel);
    if (!$carousel.hasClass('slick-initialized')) {
      initCarousel();
    } else {
      $carousel.slick('refresh');
    }

    setTimeout(() => {
      window.$(selectors.wrapper).addClass('se-opened');
    }, 200);
  });
})();